<template>
  <div class="home">
    <!-- Bloque inicial en Desktop -->
    <v-container fluid class="py-0 px-0 d-none d-md-block">
      <v-row align="center" style="background-color: #11274C;">
        <v-col cols="12" md="6" class="py-0">
          <v-carousel
            v-model="slider_home"
            height="calc(100vh - 100px)"
            hide-delimiter-background
            :show-arrows="true"
            :hide-delimiters="true"
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
              transition="scroll-x-reverse-transition"
              reverse-transition="scroll-x-reverse-transition"
            >
              <img
                :src="'https://www.visionlasercms.actstudio.xyz/'+slide.image_principal.path"
                style="height:100vh; width: 100%; object-fit: cover; object-position: top;"
              />
            </v-carousel-item>
          </v-carousel>
        </v-col>

        <v-col cols="6">
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <div style="height: 200px;">
                <transition name="fade-transition" mode="out-in">
                  <span
                    v-for="(slide, n) in slides"
                    v-if="slider_home == n"
                    :key="n"
                    class="blanco gotham d-block mb-12"
                    style="width: 375px; height:110px; font-size: 30px; line-height: 1.2;"
                  >{{slide.titulo}}</span>
                </transition>

                <transition name="fade-transition-element2" mode="out-in">
                  <router-link
                    v-for="(slide, n) in slides"
                    v-if="slider_home == n"
                    :key="n+'1'"
                    style="text-decoration:none;"
                    :to="slide.url"
                  >
                    <span
                      class="blanco gotham-bold d-block my-8"
                      style="font-size: 15px;"
                    >{{slide.etiqueta_link}} ></span>
                  </router-link>
                </transition>
              </div>
            </v-col>
          </v-row>

          <v-row class="row-transform">
            <v-col>
              <template>
                <span class="btn-arrow-slide" @click="slider_home++" style="cursor: pointer;">
                  <v-icon color="white">mdi-arrow-right</v-icon>
                </span>
                <div class="slide-absolute" style="position:relative;">
                  <v-sheet max-width="100%">
                    <v-slide-group
                      dark
                      :show-arrows="false"
                      :mandatory="true"
                      v-model="slider_home"
                      class="pa-4 slide-absolute"
                      style="background-color:rgb(17, 39, 76);"
                      mobile-break-point="500"
                    >
                      <v-slide-item v-for="(item, i) in slides" :key="i">
                        <v-card
                          v-bind:class="{'clase-active': i == slider_home}"
                          class="ma-4 tarjetas-slider-group"
                          :width="'calc( (50vw - 200px) / 2)'"
                          height="130"
                          elevation="0"
                          tile
                          @click="slider_home = i"
                        >
                          <v-img
                            :src="'https://visionlasercms.actstudio.xyz/'+item.image_principal.path"
                            height="130"
                          ></v-img>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                </div>
              </template>
            </v-col>

            <!-- <v-col cols="auto">
              <template v-if="slider_home == 0">
                <div>
                  <img
                    src="../assets/img/mini1.jpg"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>

              <template v-if="slider_home == 1">
                <div>
                  <img
                    src="../assets/img/2.webp"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>

              <template v-if="slider_home == 2">
                <div>
                  <img
                    src="../assets/img/3.jpg"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>
            </v-col>
            <v-col cols="auto">
              <template v-if="computed_slider == 0">
                <div @click="slider_home = computed_slider" style="cursor: pointer">
                  <img
                    src="../assets/img/mini1.jpg"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>

              <template v-if="computed_slider == 1">
                <div @click="slider_home = computed_slider" style="cursor: pointer">
                  <img
                    src="../assets/img/2.webp"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>

              <template v-if="computed_slider == 2">
                <div @click="slider_home = computed_slider" style="cursor: pointer">
                  <img
                    src="../assets/img/3.jpg"
                    style="height: 120px; width: 287px; object-fit: cover;"
                  />
                </div>
              </template>
            </v-col>-->
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina bloque inicial en Desktop -->

    <!-- Bloque inicial en Móvil -->
    <v-container class="py-0 d-md-none">
      <v-row class="text-center d-md-none" style="height: 106px;">
        <v-col cols="12" class="azul">
          <div class="texto-centro">
            <router-link to="/">
              <v-img src="@/assets/img/logo/logo-blanco.png" class="d-block mx-auto" width="80px"></v-img>
            </router-link>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="px-0 py-0 bg_azul_oscuro">
          <v-carousel
            v-model="slider_home"
            id="carousel-home-movil"
            :hide-delimiter-background="true"
            :show-arrows="false"
            height="calc(100vh - 190px)"
          >
            <v-carousel-item v-for="(slide, i) in slides" :key="i">
              <v-row>
                <v-col class="px-0 py-0">
                  <v-img
                    :src="'https://www.visionlasercms.actstudio.xyz/'+slide.image_mobile.path"
                    height="252px"
                  ></v-img>
                </v-col>
              </v-row>

              <v-row style="height: calc(100vh - 190px - 252px" align="center" class="pb-10">
                <v-col class="px-0 py-0">
                  <span
                    v-for="(slide, n) in slides"
                    :key="n+'2'"
                    v-if="slider_home == n"
                    class="gotham blanco d-block mx-auto text-center"
                    style="font-size: 20px; max-width: 272px; line-height: 1.2;"
                  >{{ slide.titulo }}</span>
                </v-col>
              </v-row>
            </v-carousel-item>
            <!-- <v-carousel-item>
              <v-row>
                <v-col class="px-0 py-0">
                  <v-img src="../assets/img/2.webp" height="252px"></v-img>
                </v-col>
              </v-row>

              <v-row style="height: calc(100vh - 190px - 252px" align="center" class="pb-10">
                <v-col class="px-0 py-0">
                  <span
                    class="gotham blanco d-block mx-auto text-center"
                    style="font-size: 20px; max-width: 272px;line-height: 1.2;"
                  >Somos el centro de más alta especialidad en oftalmología para el cuidado de tus ojos</span>
                </v-col>
              </v-row>
            </v-carousel-item>
            <v-carousel-item>
              <v-row>
                <v-col class="px-0 py-0">
                  <v-img src="../assets/img/3.jpg" height="252px"></v-img>
                </v-col>
              </v-row>

              <v-row style="height: calc(100vh - 190px - 252px" align="center" class="pb-10">
                <v-col class="px-0 py-0">
                  <span
                    class="gotham blanco d-block mx-auto text-center"
                    style="font-size: 20px; max-width: 272px;line-height: 1.2;"
                  >Somos el centro de más alta especialidad en oftalmología para el cuidado de tus ojos</span>
                </v-col>
              </v-row>
            </v-carousel-item>-->
          </v-carousel>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="px-0 py-0">
          <v-btn
            class="blanco"
            color="#2D4A7B"
            block
            height="45px"
            tile
            style="text-transform: initial;"
          >
            <v-spacer></v-spacer>
            <router-link
              style="text-decoration:none; color:white;"
              v-for="(slide, x) in slides"
              :key="x"
              :to="slide.url"
              v-if="slider_home == x"
            >
              <span class="gotham" style="font-size: 14px;">{{ slide.etiqueta_link }}</span>
            </router-link>
            <v-spacer></v-spacer>
            <v-icon size="18">mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina bloque inicial en Móvil -->

    <v-container>
      <v-row>
        <v-col class="text-center text-md-left my-md-6">
          <span class="gotham azul_oscuro subtitulo-size">Somos especialistas en</span>
        </v-col>
      </v-row>

      <!-- Inician bloques de Especialistas en Móvil -->
      <div class="d-md-none" style="position: relative;">
        <v-row>
          <v-col cols="6" class="py-2 px-2">
            <div class="bloque-especialistas-movil azul_oscuro text-center">
              <div>
                <span class="d-block mb-1 gotham" style="font-size: 16px;">Cirugía Lasik</span>
                <router-link
                  to="/servicios/cirugia-lasik"
                  class="azul_oscuro gotham"
                  style="font-size: 12px;"
                >Leer más</router-link>
              </div>
            </div>
          </v-col>

          <v-col cols="6" class="py-2 px-2">
            <div class="bloque-especialistas-movil azul_oscuro text-center">
              <div>
                <span class="d-block mb-1 gotham" style="font-size: 16px;">Catarata</span>
                <router-link
                  to="/servicios/catarata"
                  class="azul_oscuro gotham"
                  style="font-size: 12px;"
                >Leer más</router-link>
              </div>
            </div>
          </v-col>

          <v-col cols="6" class="py-2 px-2">
            <div class="bloque-especialistas-movil azul_oscuro text-center">
              <div>
                <span class="d-block mb-1 gotham" style="font-size: 16px;">Córnea</span>
                <router-link
                  to="/servicios/cornea"
                  class="azul_oscuro gotham"
                  style="font-size: 12px;"
                >Leer más</router-link>
              </div>
            </div>
          </v-col>

          <v-col cols="6" class="py-2 px-2">
            <div class="bloque-especialistas-movil azul_oscuro text-center">
              <div>
                <span class="d-block mb-1 gotham" style="font-size: 16px;">Glaucoma</span>
                <router-link
                  to="/servicios/glaucoma"
                  class="azul_oscuro gotham"
                  style="font-size: 12px;"
                >Leer más</router-link>
              </div>
            </div>
          </v-col>
        </v-row>

        <div
          style="position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);"
        >
          <v-img src="../assets/img/icono-movil.png" width="92px"></v-img>
        </div>
      </div>

      <v-row class="d-md-none">
        <v-col class="px-2">
          <router-link to="/servicios" class="not-underlined">
            <v-btn outlined color="#11274C" style="text-transform: initial;" block height="45px">
              <span class="omnes" style="font-size: 14px;">Conoce más sobre nuestros tratamientos</span>
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <!-- Terminan bloques de Especialistas en Móvil -->

      <!-- Inician bloques de Especialistas en Desktop -->
      <v-row class="d-none d-md-flex" align="center">
        <v-col align-self="center" justify-self="center" class="text-center">
          <router-link
            to="/servicios/cirugia-lasik"
            class="card-especialidad d-block not-underlined"
          >
            <v-img src="../assets/img/cirugia-lasik.png" width="70px" class="mx-auto"></v-img>
            <span class="gotham">Cirugía Lasik</span>
          </router-link>
        </v-col>
        <v-col class="text-center">
          <router-link to="/servicios/catarata" class="card-especialidad d-block not-underlined">
            <v-img src="../assets/img/catarata.png" width="70px" class="mx-auto"></v-img>
            <span class="gotham">Catarata</span>
          </router-link>
        </v-col>
        <v-col class="text-center">
          <router-link to="/servicios/cornea" class="card-especialidad d-block not-underlined">
            <v-img src="../assets/img/cornea.png" width="70px" class="mx-auto"></v-img>
            <span class="gotham">Córnea</span>
          </router-link>
        </v-col>
        <v-col class="text-center">
          <router-link to="/servicios/glaucoma" class="card-especialidad d-block not-underlined">
            <v-img src="../assets/img/glaucoma.png" width="70px" class="mx-auto"></v-img>
            <span class="gotham">Glaucoma</span>
          </router-link>
        </v-col>
        <v-col class="text-center">
          <router-link to="/servicios" class="not-underlined">
            <v-avatar color="#6C8FC9">
              <v-icon color="#FFFFFF" size="36">mdi-chevron-right</v-icon>
            </v-avatar>
            <span
              class="d-block mx-auto mt-3 azul_oscuro gotham"
              style="width: 200px; border-bottom: 1px solid #6C8FC9; font-size: 16px;"
            >Conoce más sobre nuestros tratamientos</span>
          </router-link>
        </v-col>
      </v-row>
      <!-- Terminan bloques de Especialistas en Desktop -->

      <v-row class="mt-6 row-banner-home">
        <v-col cols="12" sm="5" class="px-0 pb-0 pb-sm-3">
          <v-img src="@/assets/img/bannerHome/eye-doctor1.jpg" height="100%" width="100%"></v-img>
        </v-col>
        <v-col cols="12" sm="7" class="px-0 pt-0 pt-sm-3 position-relative">
          <div class="background-blue div-banner-text d-flex">
            <div class="div-banner-content text-white">
              <h1 class="mb-2 exo div-banner-content-title">Telemedicina y consulta presencial</h1>

              <h4 class="mb-0 mb-sm-8 gotham div-banner-content-subtitle">La forma más práctica y segura de realizar tus pagos.</h4>

              <!-- **********inicia botón oculto en mobile******* -->
              <div class="d-none d-sm-block">
                <v-btn
                  height="45"
                  width="100%"
                  color="#2E4A7C"
                  to="/pago-en-linea"
                  :ripple="false"
                  elevation="0"
                  tile
                >
                  <span
                    class="gotham text-transform-none text-white div-banner-content-btn-text"
                  >Pago en línea de consultas</span>
                </v-btn>
              </div>
              <!-- ***********termina botón oculto en mobile******* -->
            </div>
          </div>

          <!-- **********inicia botón oculto en desk******* -->
          <div class="d-sm-none">
            <v-btn
              height="45"
              width="100%"
              color="#2E4A7C"
              to="/pago-en-linea"
              :ripple="false"
              elevation="0"
              tile
            >
              <span
                class="gotham text-transform-none text-white div-banner-content-btn-text"
              >Pago en línea de consultas</span>
            </v-btn>
          </div>
          <!-- **********inicia botón oculto en desk******* -->
        </v-col>
      </v-row>

      <v-row class="mt-12 mt-sm-0">
        <v-col class="text-center text-md-left mt-3 my-md-6">
          <span
            class="gotham azul_oscuro subtitulo-size"
            style="line-height: 1.2;"
          >¿Por qué somos tu mejor opción?</span>
        </v-col>
      </v-row>

      <!-- Inician bloques de ¿por qué somos tu mejor opción? en Móvil -->
      <v-row class="d-md-none mt-6">
        <v-col cols="12" class="px-0 py-0">
          <v-carousel
            id="carousel-mejor-opcion-movil"
            height="412px"
            :hide-delimiter-background="true"
            :show-arrows="false"
          >
            <v-carousel-item class="text-center">
              <v-img src="../assets/img/tecnologia.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px;">Tecnología</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >De alta calidad a tu servicio</span>
            </v-carousel-item>

            <v-carousel-item class="text-center">
              <v-img src="../assets/img/medicos-especialistas.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span
                  class="gotham mx-auto"
                  style="font-size: 16px; max-width: 250px;"
                >Médicos Especialistas</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >Tratamos cualquier padecimiento</span>
            </v-carousel-item>

            <v-carousel-item class="text-center">
              <v-img src="../assets/img/valores.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px;">Valores</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >Responsabilidad, eficiencia y calidad</span>
            </v-carousel-item>

            <v-carousel-item class="text-center">
              <v-img src="../assets/img/innovacion.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px;">Innovación</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >Investigación y aplicación de nuevos conocimientos</span>
            </v-carousel-item>

            <v-carousel-item class="text-center">
              <v-img src="../assets/img/personas.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px;">Personas</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >Cooperación médica para una atención eficaz y humana</span>
            </v-carousel-item>

            <v-carousel-item class="text-center">
              <v-img src="../assets/img/pasion.jpg" height="243px">
                <div
                  style="height: 72px; margin-top: 171px; position: relative;overflow: visible; background: rgb(17, 39, 76); background: linear-gradient(0deg, rgba(17, 39, 76, 1) 0%, rgba(9, 9, 121, 0) 100%);"
                ></div>
              </v-img>
              <v-btn
                height="48px"
                class="mx-auto d-block"
                style="transform: translateY(-50%); text-transform: initial;"
                width="265px"
                color="#2D4A7B"
                rounded
                :ripple="false"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px;">Pasión</span>
              </v-btn>
              <span
                class="mt-6 d-block gotham azul_oscuro mx-auto"
                style="font-size: 14px; max-width: 250px;"
              >Por brindarte una mejor vista</span>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
      <!-- Terminan bloques de ¿por qué somos tu mejor opción? en Móvil -->

      <!-- Inician bloques de ¿por qué somos tu mejor opción? en Desktop -->
      <v-row class="d-none d-md-flex">
        <v-col cols="4">
          <v-img src="../assets/img/tecnologia.jpg" class="text-center mejor-opcion" height="284">
            <div style="padding-top: 204px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Tecnología</span>
              <span
                class="d-block blanco gotham"
                style="font-size: 16px; line-height: 1.2;"
              >De alta calidad a tu servicio</span>
            </div>
          </v-img>
        </v-col>

        <v-col cols="4">
          <v-img
            src="../assets/img/medicos-especialistas.jpg"
            class="text-center mejor-opcion"
            height="284"
          >
            <div style="padding-top: 204px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Médicos Especialistas</span>
              <span
                class="d-block blanco gotham"
                style="font-size: 16px; line-height: 1.2;"
              >Tratamos cualquier padecimiento</span>
            </div>
          </v-img>
        </v-col>

        <v-col cols="4">
          <v-img src="../assets/img/valores.jpg" class="text-center mejor-opcion" height="284">
            <div style="padding-top: 204px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Valores</span>
              <span
                class="d-block blanco gotham"
                style="font-size: 16px; line-height: 1.2;"
              >Responsabilidad, eficiencia y calidad</span>
            </div>
          </v-img>
        </v-col>

        <v-col cols="4">
          <v-img src="../assets/img/innovacion.jpg" class="text-center mejor-opcion" height="284">
            <div style="padding-top: 184px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Innovación</span>
              <span
                class="d-block blanco gotham mx-auto"
                style="font-size: 16px; width: 248px; line-height: 1.2;"
              >Investigación y aplicación de nuevos conocimientos</span>
            </div>
          </v-img>
        </v-col>

        <v-col cols="4">
          <v-img src="../assets/img/personas.jpg" class="text-center mejor-opcion" height="284">
            <div style="padding-top: 184px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Personas</span>
              <span
                class="d-block blanco gotham mx-auto"
                style="font-size: 16px; width: 254px; line-height: 1.2;"
              >Cooperación médica para una atención eficaz y humana</span>
            </div>
          </v-img>
        </v-col>

        <v-col cols="4">
          <v-img src="../assets/img/pasion.jpg" class="text-center mejor-opcion" height="284">
            <div style="padding-top: 184px;">
              <span class="d-block blanco gotham" style="font-size: 20px;">Pasión</span>
              <span
                class="d-block blanco gotham"
                style="font-size: 16px; line-height: 1.2;"
              >Por brindarte una mejor vista</span>
            </div>
          </v-img>
        </v-col>
      </v-row>
      <!-- Terminan bloques de ¿por qué somos tu mejor opción? en Desktop -->
    </v-container>

    <!-- Inicia bloque de visita nuestra tienda en Desktop -->
    <v-container fluid class="d-none d-md-block">
      <v-row align="center" class="mt-md-6 mb-md-12 pb-md-4">
        <v-col cols="12" md="6" class="px-0">
          <v-img
            :src="'https://www.visionlasercms.actstudio.xyz/'+imagenTienda.imagenTienda.path"
            height="376px"
          ></v-img>
        </v-col>

        <v-col
          cols="12"
          md="6"
          class="text-center px-0 pb-0"
          style="padding-top: 80px; background-color: #E8EEF7;"
        >
          <span class="gotham subtitulo-size azul_oscuro d-block my-3">Tienda en línea</span>
          <span class="gotham subtitulo-size azul_oscuro d-block my-3">!Proximamente¡</span>

          <img src="../assets/img/lentes.svg" width="104px" />

          <v-btn
            tile
            color="#6C8FC9"
            width="300px"
            class="d-none mx-auto"
            :ripple="false"
            style="transform: translateY(50%); text-transform: initial;"
            elevation="0"
            height="57px"
          >
            <span class="gotham" style="font-size: 16px;">
              ¡Compra tu armazón
              <span class="gotham-bold">aquí</span>!
            </span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="bg_azul_oscuro" style="height: 321px" align="center">
        <v-col cols="12" md="6" class="text-center py-0">
          <span
            class="d-block mx-auto gotham-bold blanco"
            style="font-size: 16px;"
          >Conoce a nuestros especialistas</span>
          <span
            class="blanco gotham d-block mx-auto mt-12"
            style="font-size: 25px; max-width: 463px; line-height: 1.2;"
          >Contamos con expertos preparados para brindarte la mejor solución</span>
        </v-col>
        <v-col cols="12" md="6" class="py-0" style="background-color: white;">
          <a href="https://goo.gl/maps/GfAEqHhRYNVqM8i77" target="_blank">
            <v-img src="../assets/img/Mapa-con-ubicacion.jpg" height="271px"></v-img>
          </a>
          <!-- <iframe src="https://snazzymaps.com/embed/202130" width="100%" height="253px" class="d-block" style="border:none;"></iframe> -->
          <div
            class="d-block blanco text-center gotham pt-4"
            style="height: 50px; background-color: #2D4A7B;"
          >Av. Venustiano Carranza No. 2055 Col. Jardín, C.P. 78270 San Luis Potosí, S.L.P.</div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina bloque de visita nuestra tienda en Desktop -->

    <!-- Inicia bloque de visita nuestra tienda en Móvil -->
    <v-container class="d-md-none pb-0 py-0">
      <v-row>
        <v-col class="py-0">
          <v-img
            :src="'https://www.visionlasercms.actstudio.xyz/'+imagenTienda.imagenTienda.path"
            height="183px"
            style="transform: translateY(30%)"
            class="d-block mx-auto"
          ></v-img>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          class="text-center pb-0"
          style="background-color: #E8EEF7; height:252px; padding-top: 95px;"
        >
          <span class="gotham azul_oscuro subtitulo-size d-block mx-auto">Tienda en línea</span>
          <span class="gotham azul_oscuro subtitulo-size d-block mx-auto">!Proximamente¡</span>

          <img
            src="../assets/img/lentes-movil.png"
            width="93px"
            :contain="false"
            class="my-6 d-block mx-auto"
          />

          <v-btn
            elevation="0"
            tile
            color="#6C8FC9"
            height="57px"
            style="text-transform: initial; transform: translateY(10px); z-index: 1;"
            width="300"
            class="d-none"
          >
            <span class="gotham" style="font-size: 14px;">
              ¡Compra tu armazón
              <span class="gotham-bold">aquí</span>!
            </span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-0 px-0">
          <v-img src="../assets/img/Mapa-con-ubicacion.jpg" height="317px"></v-img>
        </v-col>
      </v-row>

      <v-row style="height: 122px;" align="center">
        <v-col class="text-center py-0">
          <span class="gotham azul_oscuro" style="font-size: 14px; max-width: 272px;">
            Av. Venustiano Carranza No.
            <br />2055 Col. Jardín, C.P. 78270
            <br />San Luis Potosí, S.L.P.
          </span>
        </v-col>
      </v-row>

      <v-row class>
        <v-col class="px-0 blanco text-center bg_azul_oscuro">
          <span
            class="gotham-bold d-block my-8"
            style="font-size:16px;"
          >Conoce a nuestros especialistas</span>
          <span class="gotham d-block mb-8" style="font-size: 14px;">
            Contamos con expertos
            <br />preparados para brindarte
            <br />la mejor solución
          </span>
        </v-col>
      </v-row>
    </v-container>
    <!-- Inicia bloque de visita nuestra tienda en Móvil -->

    <!-- ******************Alerta azul*************** -->
    <div>
      <v-container class="d-none d-md-block" id="alertBlue">
        <div>
          <v-alert
            v-model="alert"
            dismissible
            elevation="0"
            color="#6C8FC9"
            dense
            class="alert-blue-real"
            style="border-radius: 0;"
          >
            <v-row align="center">
              <v-col cols="6" class="d-flex justify-center">
                <div>
                  <b class="gotham-bold" style="font-size: 16px;">Contacto</b>
                </div>
                <div class="ml-5 border-bottom-alert">
                  <span class="gotham" style="font-size: 14px;">¿Quieres agendar una cita?</span>
                </div>
              </v-col>

              <v-col cols="6" class="pt-0 pb-0 d-flex justify-center">
                <div class="ml-5">
                  <v-icon>mdi-phone</v-icon>
                  <div class="d-inline-block" style="width: 20px;">
                    <hr
                      style="border-color: #2D4A7B; transform: translateY(-5px); border-style: solid; border-top: 0px;"
                    />
                  </div>
                  <span class="gotham-bold mx-2" style="font-size: 16px;">01 (444) 833 2020</span>
                </div>
              </v-col>
            </v-row>
          </v-alert>
        </div>
      </v-container>
    </div>
    <!-- ******************/Alerta azul*************** -->
  </div>
</template>

<script>
export default {
  name: "home",
  data: () => ({
    colores: {
      azul_claro: "#2D4A7B",
      azul_oscuro: "#11274C"
    },
    slider_home: 0,
    alert: true,
    model: null,
    slides: [],
    imagenTienda: {
      imagenTienda: {
        path: ""
      }
    }
  }),
  created: function() {
    fetch(
      "https://www.visionlasercms.actstudio.xyz/api/collections/get/slides?token=6aee4c15a91b07822487782947079c",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {}
        })
      }
    )
      .then(res => res.json())
      .then(res => (this.slides = res.entries));

    //promesa singleton ImagenTienda
    fetch(
      "https://www.visionlasercms.actstudio.xyz/api/singletons/get/ImagenTienda?token=6aee4c15a91b07822487782947079c"
    )
      .then(data => data.json())
      .then(data => (this.imagenTienda = data));
  }
};
</script>
